// config
import * as http from 'utils/http';
import config from 'config';
// utils
import ticketService from '../ticketService';

const getResultsWithDeadlineWarning = (results) => {
  return results.map((r) => {
    const hasDeadlineWarning = ticketService.bussiness.hasDeadlineWarning(r);
    return {
      ...r,
      hasDeadlineWarning,
    };
  });
};

const getTickets = async (...args) => {
  const endpoint = args[0].replace('tickets/', '');
  const data = await http.get(`${config.API_URL}price-negotiation/tickets/${endpoint}`);
  const resultsWithDeadlineWarningStatus = getResultsWithDeadlineWarning([...data.results]);
  return resultsWithDeadlineWarningStatus;
};

export default getTickets;
